import script from "./HtmlInputWithVariables.vue?vue&type=script&lang=ts&setup=true"
export * from "./HtmlInputWithVariables.vue?vue&type=script&lang=ts&setup=true"

import "./HtmlInputWithVariables.vue?vue&type=style&index=0&id=4fc1b05b&lang=scss"

const __exports__ = script;

export default __exports__